const localSave = {
  set<T>(key: string, value: T) {

    if(typeof value === 'string') {
      localStorage.setItem(key, value)
    }else {
      localStorage.setItem(key, JSON.stringify(value))
    }
    
  },
  read<T>(key: string): T|string {
    const stringItem = localStorage.getItem(key)
    if(typeof stringItem === 'string') {
      return stringItem
    }else if(stringItem){
      return JSON.parse(stringItem)
    }
    return ''
  }
}

export default localSave
